import cn from 'classnames'

import css from './index.module.scss'

type ContainerProps = {
  children: React.ReactNode
  size?: 'md'
  className?: string
  section?: boolean
} & React.HTMLAttributes<HTMLDivElement>

const Container = ({ children, size = 'md', className, section = false, ...props }: ContainerProps) => {
  return (
    <div className={cn([css.container, css[`container--${size}`], className])} {...props}>
      {children}
    </div>
  )
}

export default Container
